export default __webpack_public_path__ + "static/media/PHOTO-2025-03-31-22-45-46.ad2ed127.jpg";